var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-lg btn-link",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      },
      [
        _c("i", {
          staticClass: "fa fa-arrow-left",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Back")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "border-box",
        staticStyle: {
          "min-width": "400px",
          width: "40vw",
          margin: "auto",
          "margin-top": "100px",
        },
      },
      [
        _c("div", [
          _c("h3", { staticClass: "fg-color-blue" }, [
            _vm._v("Change your password"),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Password" } }, [
                _vm._v("New password:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "password" },
                domProps: { value: _vm.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.password = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Password", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              staticClass: "form-group",
            },
            [
              _c("label", { attrs: { for: "PasswordConfirmation" } }, [
                _vm._v("New password confirmation:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.passwordConfirmation,
                    expression: "passwordConfirmation",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "password" },
                domProps: { value: _vm.passwordConfirmation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.passwordConfirmation = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-lg btn-block",
              attrs: { type: "button", disabled: !_vm.isValid },
              on: { click: _vm.handleChangePasswordCommandV1 },
            },
            [_vm._v("Change password")]
          ),
        ]),
        _vm._v(" "),
        _vm.passwordPolicy
          ? _c(
              "div",
              { staticStyle: { "margin-top": "25px", "font-size": "16px" } },
              [
                _c("strong", [_vm._v("Password validation requirements:")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticStyle: { "margin-top": "8px" } },
                  _vm._l(_vm.passwordPolicy.Rules, function (rule) {
                    return _c("li", [_vm._v(_vm._s(rule))])
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }